export const SHIMANO_FORM_LAYOUT = {
  orderType: {
    element: {
      label: 'control-label',
      host: 'master-form',
    },
    grid: {
      control: 'col-sm-12 col-lg-6 p-0 mw-custom-320',
    },
  },
  requestedDeliveryDate: {
    element: {
      label: 'control-label',
      host: 'master-form',
    },
    grid: {
      control: 'col-sm-12 col-lg-6 p-0 pl-lg-3 pt-lg-3 pb-lg-3 pr-lg-0 mw-custom-336',
    },
  },
  poNumberSnah: {
    element: {
      label: 'control-label',
      host: 'master-form full-block',
    },
    grid: {
      control: 'col-sm-12 col-lg-6 p-0 mw-custom-320',
    },
  },
  poNumber: {
    element: {
      label: 'control-label',
      host: 'master-form full-block',
    },
    grid: {
      control: 'col-sm-12 col-lg-6 p-0 mw-custom-320',
    },
  },
  fullOrderBasedOnAvailability: {
    element: {
      label: 'control-label',
      host: 'master-form full-block',
    },
    grid: {
      control: 'col-sm-12 col-lg-12 p-0',
    },
  },
  emailAddresses: {
    element: {
      label: 'control-label',
      host: 'master-form full-block border-top-1 pb-0 pt-4 border-top',
    },
    grid: {
      control: 'col-sm-12 col-lg-6 p-0 mw-custom-320',
    },
  },
  requestedCancelOrderDate: {
    element: {
      label: 'control-label',
      host: 'master-form',
    },
    grid: {
      control: 'col-sm-12 col-lg-6 p-0 pl-lg-3 pt-lg-3 pb-lg-3 pr-lg-0 mw-custom-336',
    },
  },
};
